import { MuiAlert, strIsNullOrEmpty } from '@fox/atoms';
import { AutoDataGrid } from '@fox/data-grid';
import { ReviewProps } from '@fox/import-core';
import { FlexColumnCentered, FlexColumnSpaced } from '@fox/layout';
import { sanitize } from 'dompurify';
import { useImporterContext } from './importer-context';

export function ImportReview(
	props: ReviewProps<Record<string, string>> & {
		reviewText?: string;
	}
) {
	const { data, mappedColumns, reviewText } = props;
	const { financialOptions, mapTypes, error } = useImporterContext();
	const totalPriceInDollars = (data.length * financialOptions.pricePerRow) / 100;

	return (
		<FlexColumnSpaced>
			<FlexColumnCentered style={{ gap: '2rem' }}>
				{error ? <MuiAlert severity="error">{error}</MuiAlert> : null}
				{strIsNullOrEmpty(reviewText) ? <></> : <div dangerouslySetInnerHTML={{ __html: sanitize(reviewText) }} />}

				<MuiAlert>{`You will be invoiced: $${totalPriceInDollars.toLocaleString()}`}</MuiAlert>
			</FlexColumnCentered>
			<AutoDataGrid<Record<string, string>>
				data={data}
				id="receipt-review"
				getRowKey={a => a['record_id']}
				loading={false}
				columns={[
					{
						dataIndex: 'record_id',
						title: 'Id',
						initialWidth: 200,
						render: (_, row) => {
							return row['record_id'];
						}
					},
					...mappedColumns.map(column => {
						return {
							dataIndex: column,
							title: mapTypes.find(t => t.key === column)?.title ?? column,
							initialWidth: 200,
							render: (_, row) => {
								return row[column];
							}
						};
					})
				]}
			/>
		</FlexColumnSpaced>
	);
}
